/*
 * Лента дня одного мастера — раскладка журнала на телефоне (360).
 *
 * Отдельный файл, а не медиазапрос внутри сетки: это ДРУГОЙ экран, а не та же сетка
 * в узком окне. Размеры отсюда — из макета «Мастер - П0.dc.html», экран 5-М1.
 */

.list {
  display: flex;
  flex: 1;
  flex-direction: column;
  gap: 6px;
  min-height: 0;
  padding: 0 var(--space-4) var(--space-2);
  overflow-y: auto;
}

/* Выбор мастера. Мастер видит только себя, администратор с телефона — выбирает. */
.picker {
  display: flex;
  flex: none;
  gap: 6px;
  padding: var(--space-2) var(--space-4);
  overflow-x: auto;
}

.pickerChip {
  flex: none;
  min-height: var(--touch-min-target);
  padding: 6px 12px;
  font-size: var(--font-size-md);
  font-weight: var(--font-weight-semibold);
  color: var(--text-secondary);
  white-space: nowrap;
  cursor: pointer;
  background: var(--bg-card);
  border: 1px solid var(--border-strong);
  border-radius: var(--radius-pill);
}

.pickerChipActive {
  color: var(--text-on-nav-active);
  background: var(--bg-nav);
  border-color: var(--bg-nav);
}

/* Строка смены: она же подпись возраста данных — без неё экран врёт о свежести. */
.shiftLine {
  flex: none;
  padding: 0 var(--space-4) 6px;
  font-size: var(--font-size-xs);
  font-weight: var(--font-weight-semibold);
  color: var(--text-secondary);
  letter-spacing: 0.08em;
  text-transform: uppercase;
}

.row {
  display: flex;
  flex: none;
  flex-direction: column;
  gap: 6px;
  padding: 12px 14px;
  overflow: hidden;
  background: var(--bg-card);
  border: 1px solid var(--border);
  border-radius: 14px;
}

/* Ближайшая запись выделена: «кто следующий» читается без прокрутки (ТЗ §5.16). */
.rowNext {
  border: 1.5px solid var(--accent);
}

/* Прошедшее приглушено, но не спрятано: по нему мастер сверяет, что уже сделал. */
.rowPast {
  opacity: 0.7;
}

.rowTop {
  display: flex;
  gap: var(--space-2);
  align-items: center;
  min-width: 0;
}

.time {
  flex: none;
  font-size: var(--font-size-base);
  font-weight: var(--font-weight-semibold);
  font-variant-numeric: tabular-nums;
}

.timePast {
  color: var(--text-secondary);
}

.nextBadge {
  flex: none;
  padding: 1px var(--space-2);
  font-size: var(--font-size-sm);
  font-weight: var(--font-weight-semibold);
  color: var(--status-in-progress-fg);
  background: var(--status-in-progress-bg);
  border-radius: var(--radius-pill);
}

.statusBadge {
  flex: none;
  margin-left: auto;
  padding: 2px var(--space-2);
  font-size: var(--font-size-sm);
  font-weight: var(--font-weight-semibold);
  border-radius: var(--radius-pill);
}

.statusPending {
  color: var(--status-pending-fg);
  background: var(--status-pending-bg);
}

.statusRunning {
  color: var(--status-in-progress-fg);
  background: var(--status-in-progress-bg);
}

.statusCompleted {
  color: var(--status-completed-fg);
  background: var(--status-completed-bg);
}

.statusCancelled {
  color: var(--status-cancelled-fg);
  background: var(--status-cancelled-bg);
  text-decoration: line-through;
}

.statusNoShow {
  color: var(--status-no-show-fg);
  background: var(--status-no-show-bg);
}

.rowBody {
  display: flex;
  flex-direction: column;
  gap: 2px;
  min-width: 0;
}

.client {
  overflow: hidden;
  font-size: var(--font-size-lg);
  font-weight: var(--font-weight-semibold);
  white-space: nowrap;
  text-overflow: ellipsis;
}

.clientStruck {
  text-decoration: line-through;
}

.firstVisit {
  margin-left: 6px;
  font-size: var(--font-size-sm);
  font-weight: var(--font-weight-semibold);
  color: var(--text-secondary);
}

.service {
  font-size: var(--font-size-md);
  line-height: 1.35;
  color: var(--text-secondary);
}

/* Закреплённую заметку нельзя не прочитать: аллергия и формула окрашивания живут здесь. */
.pinnedNote {
  font-size: var(--font-size-md);
  font-weight: var(--font-weight-medium);
  color: var(--status-pending-fg);
}

/* Промежуток — строка, а не пустота: в списке пустоту не видно (ТЗ §2.6). */
.gap {
  display: flex;
  flex: none;
  gap: var(--space-2);
  align-items: center;
  padding: 10px 14px;
  font-size: var(--font-size-base);
  color: var(--text-secondary);
  background: transparent;
  border: 1px dashed var(--border);
  border-radius: 14px;
}

/*
 * Нажимаемые строки ленты (5-А1). Кнопка, а не div с обработчиком: на телефоне это
 * цель для пальца, она обязана попадать в обход по Tab, озвучиваться как действие
 * и иметь высоту не меньше 44 px. Текст выравнивается влево — иначе браузер центрует
 * его по-кнопочному, и лента перестаёт читаться колонкой.
 */
.rowTappable,
.gapTappable {
  width: 100%;
  min-height: 44px;
  font: inherit;
  color: inherit;
  text-align: left;
  cursor: pointer;
}

.gapTappable {
  justify-content: space-between;
}

/* Запись без исполнителя: её ещё предстоит разобрать, и это видно до чтения текста. */
.rowUnassigned {
  border: 1.5px solid var(--note-fg, var(--border-strong));
}

/*
 * Имя мастера в общей ленте. Подложка — цвет мастера из справочника: в списке на весь
 * салон имя без цвета теряется среди клиентских имён, а цвет здесь — данные, а не
 * оформление, поэтому он приходит переменной от master-color.
 */
.master {
  padding: 1px 8px;
  font-size: var(--font-size-sm);
  white-space: nowrap;
  /* Фон и цвет текста даёт класс .plnr-master-tint (styles/base.css) по --master-h/s. */
  border-radius: var(--radius-pill);
}

.masterNone {
  color: var(--note-fg);
  background: var(--note-bg);
}

/* «Без мастера: 1 · назначьте мастера» — строка-счётчик над лентой. */
.unassignedLine {
  display: flex;
  flex: none;
  gap: var(--space-2);
  align-items: center;
  justify-content: space-between;
  width: 100%;
  min-height: 44px;
  margin-bottom: var(--space-2);
  padding: 10px 14px;
  font: inherit;
  font-size: var(--font-size-sm);
  color: var(--note-fg);
  text-align: left;
  cursor: pointer;
  background: var(--note-bg);
  border: 1px solid var(--note-border);
  border-radius: 14px;
}

/*
 * Зона большого пальца. Панель прижата к низу экрана и не уезжает вместе с лентой:
 * «Записать» — действие, за которым администратор тянется, не глядя, и искать его
 * прокруткой он не должен.
 */
/*
 * Кнопка «Записать» стоит в тех же полях, что и карточки над ней (16 px от края).
 * Во всю ширину, вплотную к краям экрана, она читалась как оторвавшаяся полоса,
 * а скругление без полей — как обрезанный край.
 */
.thumbBar {
  position: sticky;
  bottom: 0;
  z-index: 2;
  display: flex;
  flex: none;
  flex-direction: column;
  gap: 4px;
  padding: var(--space-2) var(--space-4) var(--space-3);
  background: linear-gradient(to top, var(--bg-workspace) 70%, transparent);
}

.thumbButton {
  width: 100%;
  min-height: 48px;
  font: inherit;
  font-size: var(--font-size-md);
  font-weight: var(--font-weight-semibold);
  color: var(--text-on-accent);
  cursor: pointer;
  background: var(--accent);
  border: 0;
  border-radius: 14px;
}

.thumbButton:disabled {
  cursor: not-allowed;
  opacity: 0.55;
}

.thumbDenied {
  font-size: var(--font-size-sm);
  line-height: 1.35;
  color: var(--text-secondary);
  text-align: center;
}

.busyRow {
  display: flex;
  flex: none;
  gap: var(--space-2);
  align-items: center;
  padding: 10px 14px;
  font-size: var(--font-size-base);
  color: var(--text-secondary);
  background: transparent;
  border: 1px dotted var(--border-strong);
  border-radius: 14px;
}

.holdRow {
  display: flex;
  flex: none;
  flex-direction: column;
  gap: 2px;
  padding: 10px 14px;
  font-size: var(--font-size-md);
  color: var(--hold-online-accent);
  background: var(--hold-online-bg);
  border: 1.5px dashed var(--hold-online-accent);
  border-radius: 14px;
}

.holdQuarantineRow {
  color: var(--hold-quarantine-fg);
  background: var(--hold-quarantine-bg);
  border: 1px dashed var(--hold-quarantine-border);
}

/*
 * Нажимаемая строка карантина. Кнопка, а не div с обработчиком: в ленте телефона
 * это цель для пальца, и она обязана попадать в обход по Tab и озвучиваться как
 * действие. Текст выравнивается влево — иначе браузер центрует его по-кнопочному.
 */
.holdRowTappable {
  font: inherit;
  text-align: left;
  cursor: pointer;
  /* Высота цели для пальца — не меньше 44 px, как у остальных действий ленты. */
  min-height: 44px;
}

.holdSub {
  font-variant-numeric: tabular-nums;
}

.empty {
  display: flex;
  flex: none;
  flex-direction: column;
  gap: 6px;
  margin-top: var(--space-2);
  padding: 22px var(--space-4);
  border: 1px dashed var(--border);
  border-radius: 14px;
}

.emptyTitle {
  margin: 0;
  font-size: var(--font-size-base);
  font-weight: var(--font-weight-semibold);
}

.emptyText {
  margin: 0;
  font-size: var(--font-size-md);
  line-height: 1.5;
  color: var(--text-secondary);
  text-wrap: pretty;
}
